<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <import-logs type="users"></import-logs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ImportLogs from './imports/ImportLogs';

    export default {

        components: {
            ImportLogs
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.users'),
                        route: '/socrates/ui/accounts/users'
                    },
                    {
                        name: this.$t('common.import'),
                    },
                ]
            }
        },
    }
</script>
